import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { StatusCodes } from 'api/types';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import config from '../config';
import { Duration } from '../constants';

async function getStatus(axios: AxiosInstance): Promise<StatusCodes> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/utilities/status`);
  return data;
}

export default function useStatusQuery() {
  const axios = useAxios();
  const toast = useToast();
  const navigate = useNavigate();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getStatus(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    staleTime: Duration.Minute * 60,
  });

  useEffect(() => {
    if (query.isError) {
      const error = query.error as any;
      if (error?.response?.status !== 503) {
        manageErrorResponse(toast, error);
      }
      if (error?.response?.status >= 500 && error?.response?.status !== 503) {
        navigate('/app/errorPage', { replace: true });
      }
    }
  }, [navigate, query.error, query.isError, toast]);

  return query;
}

export function getKey() {
  return ['StatusCodes'] as const satisfies QueryKey;
}
useStatusQuery.getKey = getKey;
